$(document).ready(function () {


    $(".ce-bodytext", '.totocontactpersonsBox').each(function(){
        var parent = $(this).parent();
        var innerHeight = $(this).height();
        var outerHeight = $(parent).height()

        if (innerHeight > outerHeight) {
            //$(this).css('maxHeight', '100%');
            $(this).addClass('collapsed');
            $('.contactpersonsToggleBody', parent).show();
            $('.contactpersonsToggleBody .expand', parent).show();
        } 
    })

    $('.contactpersonsToggleBody .expand').on('click', function(){
        //$(".ce-bodytext", $(this).closest($('.totocontactpersonsItem'))).css('maxHeight', 'unset');
        $(".ce-bodytext", $(this).closest($('.totocontactpersonsItem'))).removeClass('collapsed');
        $(".ce-bodytext", $(this).closest($('.totocontactpersonsItem'))).addClass('expanded');
        //$(this).closest('.totocontactpersonsItem').css('maxHeight', 'unset');
        $(this).closest('.totocontactpersonsItem').removeClass('collapsed');
        $(this).closest('.totocontactpersonsItem').addClass('expanded');
        $(this).hide();
        $('.collapse', $(this).parent()).show();        
    })

    $('.contactpersonsToggleBody .collapse').on('click', function(){
        /*$(".ce-bodytext", $(this).closest($('.totocontactpersonsItem'))).css('maxHeight', '100%');
        $(this).closest('.totocontactpersonsItem').css('maxHeight', '100%');*/
        $(".ce-bodytext", $(this).closest($('.totocontactpersonsItem'))).addClass('collapsed');
        $(".ce-bodytext", $(this).closest($('.totocontactpersonsItem'))).removeClass('expanded');
        $(this).closest('.totocontactpersonsItem').addClass('collapsed');
        $(this).closest('.totocontactpersonsItem').removeClass('expanded');
        $(this).hide();
        $('.expand', $(this).parent()).show(); 
    })

    
});